<template>
	<div class="yewu">
		<div class="yw_pc pt_90" v-if="!isPhone">
			<pageBanner :imgurl="banner"></pageBanner>
			<location lone="业务领域" v-if="bslist.length" :ltwo="bslist[tabact].title"></location>
			<div class="con_wrap">
				<div class="con_box flex1">
					<div class="con_left">
						<tabson :titobj="tabtit" :tablist="bslist" :actIndex="tabact" @tab-change="tabChange"></tabson>
						<br>
						<contact></contact>
					</div>
					<div class="con_right">
						<div class="tfm_tit" v-if="bslist.length">{{ bslist[tabact].title }}</div>
						<div class="rich_box img_auto" :style="{ backgroundColor: bgcolor }" style="line-height: 2 !important;" v-html="tbdata.content"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="yw_ph" v-if="isPhone">
			<Header2 :searchShow="true" pageTitle="业务领域"></Header2>
			<pageBanner2 :imgurl="banner"></pageBanner2>
			<div class="ph_tab_box flex3" v-if="bslist.length">
				<div class="ph_tab_item" v-for="(item, index) in bslist" :key="index" @click="tabChange(index)">
					<span :class="tabact == index ? 'ph_act1' : ''">{{ item.title }}</span>
				</div>
			</div>
			<div class="ph_acdata">
				<div class="mt_20 rich_box" :style="{ backgroundColor: bgcolor }" v-html="tbdata.content"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			tabtit: {
				title1: '业务领域',
				title2: 'Business Area',
			},
			tabact: 0,
			bslist: [],
			tbdata: {},
			banner: '',
			isPhone: this.$isMobile,
            bgcolor: '#fcfcfc',
		}
	},
	computed: {
		...mapState(["headList"]),
	},
	mounted() {
		this.getTabArr(this.headList);
	},
	watch: {
		$route(to, from) {
			this.tabact = Number(this.$route.query.sort - 1);
			this.businessdt();
		},
		headList(newVal, oldVal) {
			if (newVal.length) {
				this.getTabArr(newVal);
			}
		}
	},
	created() {
		if (this.$route.query.sort) {
			this.tabact = Number(this.$route.query.sort) - 1;
		}
		this.business();
	},
	methods: {
		getTabArr(arr) {
			for (let i = 0; i < arr.length; i++) {
				if (arr[i].name == '/business') {
					this.banner = this.$staticImg + arr[i].image;
				}
			}
		},
		// 业务领域分类
		async business() {
			const res = await this.$api.business();
			if (res.code == 1) {
				this.bslist = res.data;
				this.businessdt()
			}
		},
		tabChange(index) {
			this.$router.push('/business?sort=' + (index + 1));
		},
		async businessdt() {
			const res = await this.$api.businessdt({
				id: this.bslist[this.tabact].id,
			});
			if (res.code == 1) {
				this.tbdata = res.data;
				if (res.data.color != null && res.data.color != '') {
					this.bgcolor = res.data.color;
				}
			}
		},
	}
}
</script>

<style lang="scss">
.yewu {
	.yw_pc {
		.rich_box {
			padding: 20px;
			img {
				max-width: 100%;
			}
		}
	}

	.yw_ph {
		padding-top: 1.23rem;
		padding-bottom: 80px;
		.rich_box {
			img {
				max-width: 100%;
				height: auto !important;
			}
		}
	}
}
</style>